import axios from 'axios'

import config from '../../config.json'
const API_SOURCE = `${config.backend_server_url}_api/schedule/v2/`

export default async function getVesselsV2 () {
  try {
    const response = await axios.get(`${API_SOURCE}vessels/?format=json`)
    return response.data
  } catch (error) {
    console.error(error)
    return []
  }
}
